module.exports = __webpack_public_path__ + "img/ObiPetsLogo.acf59f97.svg";